const labels = {
  FaqCategories: {
    'Ref: Page title': 'FAQ',
    'Ref: Missing Faq': 'FAQ vide',
    'Ref: Go to home page': "Accédez à la page d'accueil",
  },
  FaqCategoryDetails: { 'Ref: Page title': 'Des questions' },
};
export default labels;
